export const tradeKeys = {
    all: ["trade"] as const,
    invest: (isin: string, wikifolioId: string, wikifolioSecurityId?: string) => ["trade", "invest", isin, wikifolioId, wikifolioSecurityId] as const,
    savingsPlan: (wikifolioSecurityId: string, isin: string, wkn: string) => ["trade", "savings-plan", wikifolioSecurityId, isin, wkn] as const,
    history: (wikifolioId: string, page: number) => ["trade", "history", wikifolioId, page] as const,
} as const;
